module.exports = __webpack_public_path__ + "static/media/favicon.54da764d.ico";


//////////////////
// WEBPACK FOOTER
// ./src/images/branding/advoco/favicon.ico
// module id = 1386
// module chunks = 0